export default {"src":"/_next/static/media/link-yellow.73c936df.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};